"use strict";

var _createClass = require("/home/runner/work/im-question-mark/im-question-mark/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/home/runner/work/im-question-mark/im-question-mark/node_modules/@babel/runtime/helpers/classCallCheck.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Assignable = exports.Enum = void 0;
/** @hidden @module */

var Enum = /*#__PURE__*/_createClass(function Enum(properties) {
  var _this = this;

  _classCallCheck(this, Enum);

  if (Object.keys(properties).length !== 1) {
    throw new Error('Enum can only take single value');
  }

  Object.keys(properties).map(function (key) {
    _this[key] = properties[key];
    _this.enum = key;
  });
});

exports.Enum = Enum;

var Assignable = /*#__PURE__*/_createClass(function Assignable(properties) {
  var _this2 = this;

  _classCallCheck(this, Assignable);

  Object.keys(properties).map(function (key) {
    _this2[key] = properties[key];
  });
});

exports.Assignable = Assignable;